import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { LICENSE_DGA } from '../../../utils/license-utils.js';
import { getZindexByType } from '../../../utils/style-utils';
import { selectLicense } from '../../brand/ducks/selectors.js';

const StyledRegulationsWrapper = styled.div`
	grid-area: regulations;
	position: fixed;
	width: 100%;
	top: 0.1px;
	z-index: ${props => props.zIndex};
`;

const RegulationsHeaderWrapper = ({ children }) => {
	const license = useSelector(selectLicense);
	const zIndex =
		license === LICENSE_DGA ? getZindexByType('regulations-header-dga') : getZindexByType('regulations-header');

	return <StyledRegulationsWrapper zIndex={zIndex}>{children}</StyledRegulationsWrapper>;
};

export default RegulationsHeaderWrapper;
